import Home from '@/components/layout/Home'
import Index from '@/views/Index'

const NotFound = () => import('@/views/common/NotFound')
const E404 = () => import('@/views/common/E404')
const Login = () => import('@/views/pc/user/login/Login')

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: Index,
        icon: 'icon-wujiaoxing',
        level: 1,
        meta: {
          requiresAuth: true // 是否需要登录
        }
      },
      {
        path: '/notFound',
        name: 'notFound',
        component: NotFound,
        meta: {
          requiresAuth: true // 是否需要登录
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  // {
  //   path: '/retrieve_pwd',
  //   name: 'retrieve_pwd',
  //   component: () => import('@/views/pc/user/retrieve_pwd'),
  //   meta: {
  //     title: '忘记密码',
  //     type: ''
  //   }
  // },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import('@/views/pc/user/register'),
  //   meta: {
  //     title: '注册',
  //     type: ''
  //   }
  // },
  {
    path: '/pc/update_pwd',
    name: 'update_pwd',
    component: () => import('@/views/pc/user/update_pwd'),
    meta: {
      title: '修改密码',
      type: ''
    }
  },
  {
    path: '/pc/index',
    name: 'pc_index',
    component: () => import('@/views/pc/user/index'),
    meta: {
      title: '首页',
      type: ''
    }
  },
  {
    path: '/pc/doctor_list',
    name: 'pc_doctor_list',
    component: () => import('@/views/pc/user/doctor'),
    meta: {
      title: '医生列表',
      type: ''
    }
  },
  {
    path: '/pc/doctor_detail',
    name: 'pc_doctor_detail',
    component: () => import('@/views/pc/user/doctor/detail'),
    meta: {
      title: '医生详情',
      type: ''
    }
  },
  {
    name: 'pc_subscribeDetail',
    path: '/pc/subscribeDetail',
    component: () => import('@/views/pc/user/onlineProblem/subscribeDetail/index'),
    meta: {
      title: '预约详情',
      type: 'login'
    }
  },
  {
    name: 'pc_principleAction',
    path: '/pc/principleAction',
    component: () => import('@/views/pc/user/onlineProblem/principleAction'),
    meta: {
      title: '主诉',
      type: 'login'
    }
  },
  {
    name: 'pc_healthArchives',
    path: '/pc/healthArchives',
    component: () => import('@/views/pc/user/healthArchives'),
    meta: {
      title: '健康档案',
      type: 'login'
    }
  },
  {
    name: 'healthdata',
    path: '/pc/healthdata',
    component: () => import('@/views/pc/user/healthArchives/healthdata'),
    meta: {
      title: '健康数据',
      type: 'login'
    }
  },
  {
    name: 'healthbase',
    path: '/pc/healthbase',
    component: () => import('@/views/pc/user/healthArchives/HealthBase'),
    meta: {
      title: '健康基本数据',
      type: 'login'
    }
  },
  {
    name: 'recordindex',
    path: '/pc/record',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord'),
    meta: {
      title: '健康履历',
      type: 'login'
    }
  },
  {
    name: 'healthDiseases',
    path: '/pc/record/diseases',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthDiseases'),
    meta: {
      title: '既往史',
      type: 'login'
    }
  },
  {
    name: 'healthSurgery',
    path: '/pc/record/surgery',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthSurgery'),
    meta: {
      title: '手术史',
      type: 'login'
    }
  },
  {
    name: 'healthTrauma',
    path: '/pc/record/trauma',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthTrauma'),
    meta: {
      title: '外伤史',
      type: 'login'
    }
  },
  {
    name: 'healthMetachysis',
    path: '/pc/record/metachysis',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthMetachysis'),
    meta: {
      title: '输血史',
      type: 'login'
    }
  },
  {
    name: 'healthFamilialdisease',
    path: '/pc/record/familialdisease',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthFamilialdisease'),
    meta: {
      title: '家族病史',
      type: 'login'
    }
  },
  {
    name: 'healthGeneticdisease',
    path: '/pc/record/geneticdisease',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthGeneticdisease'),
    meta: {
      title: '遗传病史',
      type: 'login'
    }
  },
  {
    name: 'healthAllergy',
    path: '/pc/record/allergy',
    component: () => import('@/views/pc/user/healthArchives/HealthRecord/healthAllergy'),
    meta: {
      title: '过敏史',
      type: 'login'
    }
  },
  {
    name: 'pc_historyType',
    path: '/pc/historyType',
    component: () => import('@/views/pc/user/history'),
    meta: {
      title: '检测报告',
      type: ''
    }
  },
  {
    name: 'pc_med',
    path: '/pc/med',
    component: () => import('@/views/pc/user/medicinalDishes/MedicineIndex'),
    meta: {
      title: '膳食推荐',
      type: 'login',
      value: '100'
    }
  },
  {
    name: 'pc_Symptom',
    path: '/pc/Symptom',
    component: () => import('@/views/pc/user/medicinalDishes/Symptom/index'),
    meta: {
      title: '症状选择',
      type: 'login',
      value: '100'

    }
  },
  {
    name: 'pc_RecipesList',
    path: '/pc/RecipesList',
    component: () => import('@/views/pc/user/medicinalDishes/Symptom/list'),
    meta: {
      title: '推荐食谱',
      type: 'login',
      value: '100'

    }
  },
  {
    name: 'pc_Recipes',
    path: '/pc/Recipes',
    component: () => import('@/views/pc/user/medicinalDishes/Recipes/index'),
    meta: {
      title: '食谱',
      type: 'login',
      value: '100'
    }
  },
  {
    name: 'pc_contact',
    path: '/pc/contact',
    component: () => import('@/views/pc/user/contactUs/index'),
    meta: {
      title: '联系我们',
      type: ''
    }
  },
  {
    name: 'pc_herbalLog',
    path: '/pc/herbalLog',
    component: () => import('@/views/pc/user/history/herbalLog'),
    meta: {
      title: '膳食推荐历史记录',
      type: ''
    }
  },
  {
    name: 'pc_consIdentiHisLog',
    path: '/pc/consIdentiHisLog',
    component: () => import('@/views/pc/user/history/consIdentiHisLog'),
    meta: {
      title: '体质辨识历史记录',
      type: ''
    }
  },
  {
    name: 'pc_pyloriGoods',
    path: '/pc/pyloriGoods',
    component: () => import('@/views/pc/user/history/pyloriGoods/index'),
    meta: {
      title: '幽门螺杆菌',
      type: ''
    }
  },
  {
    name: 'pc_pyloriGoodsDetail',
    path: '/pc/pyloriGoodsDetail',
    component: () => import('@/views/pc/user/history/pyloriGoods/detail'),
    meta: {
      title: '幽门螺杆菌报告',
      type: ''
    }
  },
  {
    name: 'pc_mirror',
    path: '/pc/mirror',
    component: () => import('@/views/pc/user/history/mirror/index'),
    meta: {
      title: 'AI魔镜',
      type: ''
    }
  },
  {
    name: 'pc_skinmgr',
    path: '/pc/skinmgr',
    component: () => import('@/views/pc/user/history/skinmgr/List'),
    meta: {
      title: '魔肌检测',
      type: ''
    }
  },
  {
    name: 'xiekang_type',
    path: '/pc/integrated/type',
    component: () => import('@/views/pc/user/integrated/type'),
    meta: {
      title: '健康数据',
      type: ''
    }
  },
  {
    name: 'bloodAnalysis',
    path: '/pc/bloodAnalysis',
    component: () => import('@/views/pc/user/integrated/list/bloodAnalysis'),
    meta: {
      title: '血液分析列表',
      type: ''
    }
  },
  {
    name: 'bloodAnalysis_detail',
    path: '/pc/bloodAnalysis/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/bloodAnalysis'),
    meta: {
      title: '血液分析详情',
      type: ''
    }
  },
  {
    name: 'bloodGlucose',
    path: '/pc/bloodGlucose',
    component: () => import('@/views/pc/user/integrated/list/bloodGlucose'),
    meta: {
      title: '血糖列表',
      type: ''
    }
  },
  {
    name: 'bloodGlucose_detail',
    path: '/pc/bloodGlucose/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/bloodGlucose'),
    meta: {
      title: '血糖详情',
      type: ''
    }
  },
  {
    name: 'blood_pressure',
    path: '/pc/blood_pressure',
    component: () => import('@/views/pc/user/integrated/list/bloodPressure'),
    meta: {
      title: '血压列表',
      type: ''
    }
  },
  {
    name: 'blood_pressure_detail',
    path: '/pc/blood_pressure/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/bloodPressure'),
    meta: {
      title: '血压详情',
      type: ''
    }
  },
  {
    name: 'weight',
    path: '/pc/weight',
    component: () => import('@/views/pc/user/integrated/list/weight'),
    meta: {
      title: '体重列表',
      type: ''
    }
  },
  {
    name: 'weight_detail',
    path: '/pc/weight/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/weight'),
    meta: {
      title: '体重详情',
      type: ''
    }
  },
  {
    name: 'fat',
    path: '/pc/fat',
    component: () => import('@/views/pc/user/integrated/list/fat'),
    meta: {
      title: '体脂列表',
      type: ''
    }
  },
  {
    name: 'fat_detail',
    path: '/pc/fat/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/fat'),
    meta: {
      title: '体脂详情',
      type: ''
    }
  },
  {
    name: 'ua',
    path: '/pc/ua',
    component: () => import('@/views/pc/user/integrated/list/ua'),
    meta: {
      title: '尿酸列表',
      type: ''
    }
  },
  {
    name: 'ua_detail',
    path: '/pc/ua/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/ua'),
    meta: {
      title: '尿酸详情',
      type: ''
    }
  },
  {
    name: 'cholesterol',
    path: '/pc/cholesterol',
    component: () => import('@/views/pc/user/integrated/list/cholesterol'),
    meta: {
      title: '胆固醇列表',
      type: ''
    }
  },
  {
    name: 'cholesterol_detail',
    path: '/pc/cholesterol/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/cholesterol'),
    meta: {
      title: '胆固醇详情',
      type: ''
    }
  },
  {
    name: 'etg',
    path: '/pc/etg',
    component: () => import('@/views/pc/user/integrated/list/etg'),
    meta: {
      title: '温度列表',
      type: ''
    }
  },
  {
    name: 'etg_detail',
    path: '/pc/etg/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/etg'),
    meta: {
      title: '温度详情',
      type: ''
    }
  },
  {
    name: 'slp',
    path: '/pc/slp',
    component: () => import('@/views/pc/user/integrated/list/slp'),
    meta: {
      title: '睡眠列表',
      type: ''
    }
  },
  {
    name: 'slp_detail',
    path: '/pc/slp/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/slp'),
    meta: {
      title: '睡眠详情',
      type: ''
    }
  },
  {
    name: 'len',
    path: '/pc/len',
    component: () => import('@/views/pc/user/integrated/list/len'),
    meta: {
      title: '运动列表',
      type: ''
    }
  },
  {
    name: 'len_detail',
    path: '/pc/len/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/len'),
    meta: {
      title: '运动详情',
      type: ''
    }
  },
  {
    name: 'bloodOxygen',
    path: '/pc/bloodOxygen',
    component: () => import('@/views/pc/user/integrated/list/bloodOxygen'),
    meta: {
      title: '运动列表',
      type: ''
    }
  },
  {
    name: 'bloodOxygen_detail',
    path: '/pc/bloodOxygen/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/bloodOxygen'),
    meta: {
      title: '运动详情',
      type: ''
    }
  },
  {
    name: 'pm',
    path: '/pc/pm',
    component: () => import('@/views/pc/user/integrated/list/pm'),
    meta: {
      title: '心率列表',
      type: ''
    }
  },
  {
    name: 'pm_detail',
    path: '/pc/pm/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/pm'),
    meta: {
      title: '心率详情',
      type: ''
    }
  },
  {
    name: 'bmd',
    path: '/pc/bmd',
    component: () => import('@/views/pc/user/integrated/list/bmd'),
    meta: {
      title: '骨密质列表',
      type: ''
    }
  },
  {
    name: 'bmd_detail',
    path: '/pc/bmd/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/bmd'),
    meta: {
      title: '骨密质详情',
      type: ''
    }
  },
  {
    name: 'corporeity',
    path: '/pc/corporeity',
    component: () => import('@/views/pc/user/integrated/list/corporeity'),
    meta: {
      title: '九型体质列表',
      type: ''
    }
  },
  {
    name: 'corporeity_detail',
    path: '/pc/corporeity/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/corporeity'),
    meta: {
      title: '九型体质详情',
      type: ''
    }
  },

  {
    name: 'composition',
    path: '/pc/composition',
    component: () => import('@/views/pc/user/integrated/list/composition'),
    meta: {
      title: '人体成分列表',
      type: ''
    }
  },
  {
    name: 'composition_detail',
    path: '/pc/composition/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/composition'),
    meta: {
      title: '人体成分详情',
      type: ''
    }
  },
  {
    name: 'healthinfo',
    path: '/pc/healthinfo',
    component: () => import('@/views/pc/user/integrated/list/healthinfo'),
    meta: {
      title: '基本体检列表',
      type: ''
    }
  },
  {
    name: 'healthinfo_detail',
    path: '/pc/healthinfo/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/healthinfo'),
    meta: {
      title: '基本体检详情',
      type: ''
    }
  },
  {
    name: 'lungInfo',
    path: '/pc/lungInfo',
    component: () => import('@/views/pc/user/integrated/list/lungInfo'),
    meta: {
      title: '肺功能列表',
      type: ''
    }
  },
  {
    name: 'lungInfo_detail',
    path: '/pc/lungInfo/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/lungInfo'),
    meta: {
      title: '肺功能详情',
      type: ''
    }
  },
  {
    name: 'urineRoutine',
    path: '/pc/urineRoutine',
    component: () => import('@/views/pc/user/integrated/list/urineRoutine'),
    meta: {
      title: '尿检列表',
      type: ''
    }
  },
  {
    name: 'urineRoutine_detail',
    path: '/pc/urineRoutine/detail/:id',
    component: () => import('@/views/pc/user/integrated/detail/urineRoutine'),
    meta: {
      title: '尿检详情',
      type: ''
    }
  },
  {
    name: 'pc_constitutionSex',
    path: '/pc/constitution/sex',
    component: () => import('@/views/pc/user/constitution/sex/index'),
    meta: {
      title: '选择性别',
      type: 'noLogin',
      value: '104'
    }
  },
  {
    name: 'pc_constitutionQuestion',
    path: '/pc/constitution/question',
    component: () => import('@/views/pc/user/constitution/question/index'),
    meta: {
      title: '体质鉴别',
      type: 'noLogin',
      value: '104'
    }
  },
  {
    name: 'pc_constitutionReport',
    path: '/pc/constitution/report',
    component: () => import('@/views/pc/user/constitution/report/index'),
    meta: {
      title: '体质报告',
      type: 'noLogin',
      value: '104'
    }
  },
  {
    name: 'pc_prescriptionReport',
    path: '/pc/prescriptionReport',
    component: () => import('@/views/pc/user/prescriptionReport'),
    meta: {
      title: '处方报告',
      type: 'login'
    }
  },

  {
    name: 'pc_pevalist',
    path: '/pc/pevalist',
    component: () => import('@/views/pc/user/history/daosh/listPage'),
    meta: {
      title: '测评列表',
      type: ''
    }
  },
  {
    name: 'pc_oldpeople',
    path: '/pc/oldpeople',
    component: () => import('@/views/pc/user/history/daosh/detailPage/A_Old_people'),
    meta: {
      title: '老年人测评体质',
      type: ''
    }
  },
  {
    name: 'pc_chinesemedicine',
    path: '/pc/chinesemedicine',
    component: () => import('@/views/pc/user/history/daosh/detailPage/B_Chinese_medicine'),
    meta: {
      title: '中医测评体质',
      type: ''
    }
  },
  {
    name: 'pc_chinesementality',
    path: '/pc/chinesementality',
    component: () => import('@/views/pc/user/history/daosh/detailPage/C_Chinesemedicine_mentality'),
    meta: {
      title: '中医心理测评',
      type: ''
    }
  },
  {
    name: 'pc_pregnancy',
    path: '/pc/pregnancy',
    component: () => import('@/views/pc/user/history/daosh/detailPage/D_Pregnancy'),
    meta: {
      title: '孕期女性健康状态测评报告',
      type: ''
    }
  },
  {
    name: 'pc_hypertension',
    path: '/pc/hypertension',
    component: () => import('@/views/pc/user/history/daosh/detailPage/E_Hypertension'),
    meta: {
      title: '高血压病辅助辩证',
      type: ''
    }
  },
  {
    name: 'pc_child',
    path: '/pc/child',
    component: () => import('@/views/pc/user/history/daosh/detailPage/F_Child'),
    meta: {
      title: '儿童体质辨识',
      type: ''
    }
  },
  {
    name: 'pc_cpmedicine',
    path: '/pc/cpmedicine',
    component: () => import('@/views/pc/user/history/daosh/detailPage/G_Chinese_patent_medicine'),
    meta: {
      title: '中成药辅助辩证',
      type: ''
    }
  },
  {
    name: 'pc_pulsecondition',
    path: '/pc/pulsecondition',
    component: () => import('@/views/pc/user/history/daosh/detailPage/H_Pulse_condition'),
    meta: {
      title: '脉象数据采集',
      type: ''
    }
  },
  {
    name: 'pc_tongue',
    path: '/pc/tongue',
    component: () => import('@/views/pc/user/history/daosh/detailPage/I_Tongue'),
    meta: {
      title: '舌象数据采集',
      type: ''
    }
  },
  {
    name: 'pc_face',
    path: '/pc/face',
    component: () => import('@/views/pc/user/history/daosh/detailPage/J_Face'),
    meta: {
      title: '面色数据采集',
      type: ''
    }
  },
  {
    name: 'pc_diabetes',
    path: '/pc/diabetes',
    component: () => import('@/views/pc/user/history/daosh/detailPage/K_Diabetes'),
    meta: {
      title: '糖尿病辅助辨识报告',
      type: ''
    }
  },
  {
    name: 'pc_scientificresearch',
    path: '/pc/scientificresearch',
    component: () => import('@/views/pc/user/history/daosh/detailPage/L_Scientific_research'),
    meta: {
      title: '科研版体质辨识报告',
      type: ''
    }
  },
  {
    name: 'pc_afterchildbirth',
    path: '/pc/afterchildbirth',
    component: () => import('@/views/pc/user/history/daosh/detailPage/M_After_childbirth'),
    meta: {
      title: '产后女性健康状态测评',
      type: ''
    }
  },
  {
    name: 'readypregnancy',
    path: '/pc/readypregnancy',
    component: () => import('@/views/pc/user/history/daosh/detailPage/N_Ready_pregnancy'),
    meta: {
      title: '备孕女性健康状态测评',
      type: ''
    }
  },
  {
    name: 'pc_infraredList',
    path: '/pc/infrared/list',
    component: () => import('@/views/pc/user/history/infrared/list'),
    meta: {
      title: '红外报告列表',
      type: ''
    }
  },
  {
    name: 'pc_infraredDetail',
    path: '/pc/infrared/detail',
    component: () => import('@/views/pc/user/history/infrared/detail'),
    meta: {
      title: '红外报告详情',
      type: ''
    }
  },
  {
    name: 'pc_inquiryCategoryQuestion',
    path: '/pc/inquiryCategoryQuestion',
    component: () => import('@/views/pc/user/onlineProblem/categoryQuestion'),
    meta: {
      title: '问诊分组问题',
      type: 'login'
    }
  },
  {
    name: 'pc_inquiry/question',
    path: '/pc/inquiry/question',
    component: () => import('@/views/pc/user/inquiry/question'),
    meta: {
      title: '问诊',
      type: 'login',
      value: '102'
    }
  },
  {
    name: 'ecgreport',
    path: '/pc/ecg/report',
    component: () => import('@/views/pc/user/history/GuanXin/report'),
    meta: {
      title: '心电报告详情',
      type: ''
    }
  },
  {
    name: 'ecglist',
    path: '/pc/ecg/list',
    component: () => import('@/views/pc/user/history/GuanXin/list'),
    meta: {
      title: '心电报告列表',
      type: ''
    }
  },
  {
    name: 'mattresslist',
    path: '/pc/mattress/list',
    component: () => import('@/views/pc/user/history/mattress/list'),
    meta: {
      title: '床垫列表',
      type: ''
    }
  },
  {
    name: 'mattressReportlist',
    path: '/pc/mattressReport/list',
    component: () => import('@/views/pc/user/history/mattress/index'),
    meta: {
      title: '床垫报告列表',
      type: ''
    }
  },
  {
    name: 'stoollist',
    path: '/pc/stool/list',
    component: () => import('@/views/pc/user/history/stool/index'),
    meta: {
      title: '智能马桶报告列表',
      type: ''
    }
  },
  {
    name: 'stooldetail',
    path: '/pc/stool/detail',
    component: () => import('@/views/pc/user/history/stool/detail'),
    meta: {
      title: '智能马桶报告',
      type: ''
    }
  },
  {
    name: 'map',
    path: '/pc/map',
    component: () => import('@/views/pc/user/map'),
    meta: {
      title: '地图页',
      type: 'login'
    }
  },
  {
    path: '/error404',
    name: 'error404',
    component: E404
  },
  {
    path: '*',
    redirect: '/notFound'
  },

]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js